import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

// Hook
import { ConfirmMessageModal2Id } from '../../hooks/useBlocker';

// Const
import { userType, userPrivilege } from 'const/nuclias/user';

// Component
import Breadcrumbs from '../../components/Breadcrumb';
import Tab from '../../components/Tab';
import ConfirmMessageModal from '../../components/ConfirmMessageModal';

// Sub pages
import MyProfile from './MyProfile';
import ApiAccess from './ApiAccess';
import RecentLogin from './RecentLogin';

const BreadCrumbComponent = props => {
  const { pathList } = props;
  return <Breadcrumbs pathList={pathList} />;
};

const defaultTabList = [
  { id: 1, label: '32fbbb019a', isActive: true }, // My profile
  { id: 2, label: '41966b154f', isActive: false }, // Recent logins
  { id: 3, label: '8af577ea58', isActive: false }, // API access
];

const defaultSiteTagOrSiteOrNotAdminTabList = [
  { id: 1, label: '32fbbb019a', isActive: true }, // My profile
  { id: 2, label: '41966b154f', isActive: false }, // Recent logins
];

const defaultPathList = [
  { label: '90b1f66519', isLink: false }, // User profile
  { label: defaultTabList[0].label, isLink: false },
];

const UserProfile = () => {
  const [tabList, setTabList] = useState(defaultTabList);
  const [pathList, setPathList] = useState([...defaultPathList]);
  const [originMyProfileData, setOriginMyProfileData] = useState({});

  const user = useSelector(state => state.user.user);
  const isSiteTagOrSiteOrNotAdmin =
    user.type === userType.siteTag ||
    user.type === userType.site ||
    user.privilege !== userPrivilege.manager
      ? true
      : false;

  useEffect(() => {
    isSiteTagOrSiteOrNotAdmin
      ? setTabList([...defaultSiteTagOrSiteOrNotAdminTabList])
      : setTabList([...defaultTabList]);
  }, [isSiteTagOrSiteOrNotAdmin]);

  const changeTab = selectedTab => {
    const newTabList = _.cloneDeep(tabList);
    const index = newTabList.findIndex(tab => tab.id === selectedTab.id);

    newTabList.map(tab => (tab.isActive = false));
    newTabList[index].isActive = true;
    setTabList(newTabList);

    const newPathList = [...pathList];
    newPathList[1].label = selectedTab.label;
    setPathList(newPathList);
  };

  const confirmLeving = answer => {
    if (answer) {
      changeTab(savingSelectedTab);
    } else {
      document.getElementById(ConfirmMessageModal2Id).hidden = true;
    }

    document.getElementById(ConfirmMessageModal2Id).hidden = true;
  };

  let savingSelectedTab = null;
  const preChangeTab = selectedTab => {
    if (tabList[0].isActive && !_.isEqual(originMyProfileData, changedMyProfileData)) {
      savingSelectedTab = selectedTab;
      document.getElementById(ConfirmMessageModal2Id).hidden = false;
      return;
    }

    changeTab(selectedTab);
  };

  let changedMyProfileData = {};
  const syncMyProfileData = data => {
    changedMyProfileData = data;
  };

  return (
    <>
      <BreadCrumbComponent pathList={pathList} />

      <Tab tabList={tabList} changeTab={preChangeTab} />

      {tabList && tabList[0] && tabList[0].isActive && (
        <MyProfile
          tabList={tabList}
          originMyProfileData={originMyProfileData}
          setOriginMyProfileData={setOriginMyProfileData}
          syncMyProfileData={syncMyProfileData}
        />
      )}
      {tabList && tabList[1] && tabList[1].isActive && (
        <RecentLogin tabList={tabList} />
      )}
      {!isSiteTagOrSiteOrNotAdmin &&
        tabList &&
        tabList[2] &&
        tabList[2].isActive && <ApiAccess tabList={tabList} />}

      <ConfirmMessageModal
        domId={ConfirmMessageModal2Id}
        confirmLeving={confirmLeving}
      />
    </>
  );
};

export default UserProfile;
